import * as microsoftTeams from "@microsoft/teams-js";

export default async function (): Promise<string> {
  return microsoftTeams.authentication.authenticate({
    url: window.location.origin + "/login-m365-auth-start",
    width: 600,
    height: 535,
  });
}
